import React, { useEffect } from "react";
import { RouteComponentProps, useLocation } from "@reach/router";
import { Spinner } from "components/Spinner/Spinner";
import "./session.scss"
import { getRefreshToken } from "api";
export interface SessionProps { }

export type Props = SessionProps & RouteComponentProps;

const Session: React.FC<Props> = props => {
    const location = useLocation();
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const accessToken = searchParams.get('accessToken')
        const refreshToken = searchParams.get('refreshToken')

        if (accessToken && refreshToken) {
            getRefreshToken(accessToken, refreshToken)
                .then(res => {
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 1000)
                })
        } else {
            window.location.href = '/';
        }
    }, [])
    return (
        <div className="session-container">
            <Spinner positionAbsolute={true} />
        </div>
    )
}

export default Session